import { createFileRoute } from '@tanstack/react-router';
import { AgentesView } from '@/modules/agentes/components/AgentesView';

export const Route = createFileRoute('/_authed/agentes')({
  component: AgentesPage,
});

function AgentesPage() {
  return <AgentesView />;
}
